import { render, staticRenderFns } from "./GbwapsLayout.vue?vue&type=template&id=7bf8de34"
import script from "./GbwapsLayout.vue?vue&type=script&lang=js"
export * from "./GbwapsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports